var _dec, _class;

import { Model, model, prop } from "mobx-keystone";
import { GesturePointModel } from "./GesturePointModel";
export let LineGestureModel = (_dec = model("combat/LineGestureModel"), _dec(_class = class LineGestureModel extends Model({
  from: prop(() => new GesturePointModel({})).withSetter(),
  to: prop(() => new GesturePointModel({})).withSetter()
}) {}) || _class);